class Notification{
    push_title: string;
    push_message: string;


    survey_status_message: string;
    action: string;

    modal: Boolean;
    image_url: string;
    modal_title: string;
    modal_message: string;

    auto: Boolean;
    cond: string;
    days_array: Array<boolean>;
    time: string;

    inactivity_reminder: Boolean;
    inactivity_days: string;
    inactivity_execution_time: string;

    
    
    
    constructor(
            push_title: string = '',
            push_message: string = '',

            survey_status_message: string = '',
            action: string = '',

            modal: Boolean = new Boolean(false),
            image_url: string = '',
            modal_title: string = '',
            modal_message: string = '',

            auto: Boolean = new Boolean(false),
            cond: string = '',
            days_array: Array<boolean> = [...new Array(7)].map(()=>false),
            time: string = '',
            inactivity_reminder: Boolean = new Boolean(false),
            inactivity_days: string = '1',
            inactivity_execution_time: string = ''

        ){
            this.push_title = push_title;
            this.push_message =push_message;


            this.survey_status_message = survey_status_message;
            this.action = action;

            this.modal = modal;
            this.image_url = image_url;
            this.modal_title = modal_title;
            this.modal_message = modal_message;

            this.auto = auto;
            this.cond = cond;
            this.days_array = days_array;
            this.time = time;

            this.inactivity_reminder = inactivity_reminder;
            this.inactivity_days = inactivity_days;
            this.inactivity_execution_time = inactivity_execution_time;
    }

}
  

class DiaryUser{
    id: string;
    diary_id: string;
    diaries: Array<Diary>;
    link: string;
    constructor(diary_id: string, id: string, diaries: Array<Diary>, link: string){
        this.id = id;
        this.diary_id = diary_id;
        this.diaries = diaries;
        this.link = link;
    }
}

class Admin{
    email: string;
    active: Boolean;
    constructor(email: string, active:Boolean){
        this.email=email;
        this.active=active;
    }
}

class Diary{
    id: string;
    name: string;
    respondent_name: string;
    description: string;
    path: string;
    url: string;
    api_key: string;
    messages: Array<Notification>;
    users: Array<DiaryUser>;
    file: any | null;
    active: Boolean;
    constructor(
        id: string = '',
        name: string = '',
        respondent_name = '',
        description = '',
        path: string = '',
        base_url: string = '',
        api_key: string = '',
        messages: Array<Notification> = [],
        users: Array<DiaryUser> = [],
        file: File | null = null,
        active: Boolean = new Boolean(false),
        )
    {
        this.id = id;
        this.name = name;
        this.respondent_name = respondent_name;
        this.description = description;
        this.path = path;
        this.url = base_url;
        this.api_key = api_key;
        this.messages = messages;
        this.users = users;
        this.active = active;
    }
}

class AppNotification{
    title: string;
    message: string;
    image_url: string;
    constructor(
        title: string = '',
        message: string = '',
        image_url: string =''
    ){
        this.title = title;
        this.message = message;
        this.image_url = image_url;
    }
}

export {Notification, Diary, DiaryUser, Admin, AppNotification}